export default `Department,Population
Capital District,7412566
Amazonas,76589
Antioquia,6407102
Arauca,262174
Atlántico,2535517
Bolívar,2070110
Boyacá,1217376
Caldas,998255
Caquetá,401849
Casanare,420504
Cauca,1464488
Cesar,1200574
Chocó,534826
Córdoba,1784783
Cundinamarca,2919060
Guainía,48114
Guaviare,82767
Huila,1100386
La Guajira,880560
Magdalena,1341746
Meta,1039722
Nariño,1630592
Norte de Santander,1491689
Putumayo,348182
Quindío,539904
Risaralda,943401
San Andrés y Providencia,61280
Santander,2184837
Sucre,904863
Tolima,1330187
Valle del Cauca,4475886
Vaupés,40797
Vichada,107808`